import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { useSelector } from "react-redux";
import { Grid } from "semantic-ui-react";
import lightning from "../../../assets/icons/lightning.svg";
import paint from "../../../assets/icons/paint.svg";
import { SOCIAL_LINKS } from "../../../app/common/constants";

export default function HowSocialMediaPromotionWorksModal() {
  const { responsive } = useSelector((state) => state.app);

  return (
    <ModalWrapper
      modalClassName="modal-ux-wrapper"
      style={{ width: !responsive.isMobile ? 590 : "98%" }}
      padding={!responsive.isMobile ? 30 : 14}
    >
      <h3 className="medium-text">Social Media Promotion</h3>
      <div className="first-paragraph">
        We’ll share your opportunity across Instagram and Facebook to our
        growing online community!
      </div>
      <Grid style={{ marginTop: 10 }}>
        <Grid.Row>
          <Grid.Column width={3} textAlign="center" verticalAlign="middle">
            <img src={lightning} alt="light" />
          </Grid.Column>
          <Grid.Column width={12}>
            <div className="info-heading-text" style={{ marginBottom: 8 }}>
              Fast & easy process
            </div>
            Simply choose the service and once your vacancy is published our
            team will take care of the rest.
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} textAlign="center" verticalAlign="middle">
            <img src={paint} alt="modern" />
          </Grid.Column>
          <Grid.Column width={12}>
            <div className="info-heading-text" style={{ marginBottom: 8 }}>
              Modern & attractive design
            </div>
            We make your jobs look great to potential applicants who can view
            your job details in one tap.
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={9}>
            <div>
              <div className="info-heading-text" style={{ marginBottom: 8 }}>
                Instagram{" "}
              </div>
              We’ll share your job as an 24hr Instagram Story and add it to our
              Job Posts Highlights so your vacancies are always visible until
              your job expires.{" "}
              <a
                className="text-link"
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Instagram profile
              </a>
            </div>
            <br />
            <div>
              <div className="info-heading-text" style={{ marginBottom: 8 }}>
                Facebook{" "}
              </div>
              We’ll share your job on our news feed, including a link, the job
              location and expiry date.{" "}
              <a
                className="text-link"
                href={SOCIAL_LINKS.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Facebook page
              </a>
            </div>
            <br />
            <img
              alt={"facebook"}
              src={
                "https://firebasestorage.googleapis.com/v0/b/helloradius-caf9d.appspot.com/o/photos%2Ffacebksocialmediaexample.jpg?alt=media&token=b5f08ddb-72a0-4b64-a352-ea2d5375d0e5"
              }
            />
          </Grid.Column>
          <Grid.Column width={6} style={{ padding: 0 }}>
            <img
              src={
                "https://firebasestorage.googleapis.com/v0/b/helloradius-caf9d.appspot.com/o/photos%2Finstasocialmediaexample.jpg?alt=media&token=bbd08eab-f33f-424f-9f85-5001e2080eee"
              }
              alt={"insta"}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <h3 className="first-paragraph">More information </h3>
            <div className="first-paragraph">
              Jobs are shared on Facebook & Instagram{" "}
              <span className="semi-bold">within 1-2 days</span> from the date
              the job was published (including on weekends).
            </div>
            <div style={{ margin: "7px 0" }}>
              On Instagram, expired jobs are removed. On Facebook, they remain
              on our news feed (expiry date is displayed on the post).
            </div>
            <div>
              Your design may vary to the examples shown and jobs may be
              featured alongside others. See our social media pages for more
              examples.
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </ModalWrapper>
  );
}
